<template>
    <div class="tree">
        <trees :treedata="treeData" ref="tree" @changeNode="changeNode"></trees>
    </div>
</template>

<script>
export default {
    props: {
        treeData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
        }
    },
    methods: {

        changeNode({ label }) {
            let id;
            let carrierId;
            // 客户
            if (label.level === 0) {
                id = label.scope_id,
                carrierId = null
                // 架构
            } else if (label.nodeType === 2) {
                id = label.scene_id,
                carrierId = null
            } else {
                // 监测点
                id = null
                carrierId = label.carrier_id
            }
            this.$emit('treeSearch', { id,carrierId })
        }
    }
}
</script>

<style lang="scss" scoped>
.tree {
    max-height: calc(100% - 50px);
    border-bottom: 1px solid #cccccc;
    overflow: auto;
}
</style>